import React from 'react'
import { Star, StarFill, StarHalf } from 'react-bootstrap-icons'

const iconFor = (value, position) => {
  if (value >= position) return StarFill
  if (value >= position - 0.5) return StarHalf
  return Star
}

export default function RatingStars({ label, value }) {
  const rated = value !== null && value !== undefined
  const score = rated ? Number(value) : 0

  return (
    <div className="flex items-center gap-1.5" title={rated ? `${label}: ${score.toFixed(1)} / 5` : `${label}: not rated yet`}>
      <span className="text-xs text-rb-mat-grey dark:text-gray-400">{label}</span>
      <span className={`flex items-center gap-0.5 text-xs ${rated ? 'text-amber-400' : 'text-gray-300 dark:text-rb-dark-mode-lighter'}`}>
        {[1, 2, 3, 4, 5].map(position => {
          const Icon = iconFor(score, position)
          return <Icon key={position} />
        })}
      </span>
      <span className="text-xs font-semibold text-rb-black dark:text-white">{rated ? score.toFixed(1) : '–'}</span>
    </div>
  )
}
